import { useCallback, useState } from 'react';

/**
 * Skeleton hook that owns which auth screen the SignIn page is currently
 * showing. Downstream stories (SIM-2/6..10) will extend the state machine;
 * the shape ({ currentScreen, goTo }) stays open for that extension.
 */
const INITIAL_SCREEN = 'passkey-detection';

const useAuthFlow = () => {
    const [currentScreen, setCurrentScreen] = useState(INITIAL_SCREEN);
    const goTo = useCallback(screen => setCurrentScreen(screen), []);

    return { currentScreen, goTo };
};

export default useAuthFlow;
